// Display labels for the SoapOperaScheduleDto enum returned by GET /api/v2/ContentSearch.
export const SOAP_OPERA_SCHEDULE_LABELS = {
  FivePM: "17h",
  SixPM: "18h",
  SevenPM: "19h",
  NinePM: "21h",
  ElevenPM: "23h",
};

export const getSoapOperaScheduleLabel = (schedule) =>
  SOAP_OPERA_SCHEDULE_LABELS[schedule];
